import { Route } from '@angular/router';
import { isAgencyGuard } from '@rma/authentication/public/util-auth-redirect';

import { campaignsRoutes } from './campaigns.routes';
import { reviewRoutes } from './reviews.routes';

export const collectRoutes: Route[] = [
  {
    path: 'reviews',
    children: reviewRoutes,
  },
  {
    path: 'campaigns',
    children: campaignsRoutes,
  },
  {
    path: 'survey',
    canActivate: [isAgencyGuard()],
    loadChildren: () => import('@rma/survey/survey'),
  },
];
